import React from 'react';
import { Button } from '_ui-core-js/React/components/Button.jsx';
import { CssAnimation } from '_ui-core-js/React/components/CssAnimation.jsx';
import _ from 'lodash';

export function ImageCard(props) {
    const { heading, link, media, block, onClickActions, cssAnimation } = props;
    const linkExists = !!_.get(link, 'href', undefined);

    const Tag = linkExists ? 'a' : 'button';

    function handleOnClick (link) {
        if (_.find(link.dataAttributes, {key:'onClickAction'})) {
            const onClickAction = _.find(link.dataAttributes, {key:'onClickAction'})
            let onClickFunction = _.noop();
        
            if (onClickAction?.value) {
                onClickFunction = onClickActions[onClickAction.value]
            }
            onClickFunction(link);
        }
    }

    return (
        <>
            <CssAnimation
                enter={{ name: 'slide-up-fade-in', duration: 0.5, delay: '0.25, hidden', easing: 'ease-out' }}
                triggerEnter={'in-view-init'}
                disable={!cssAnimation}
            >
                <Tag className={`${block}__card`} href={linkExists && link.href}>
                    <div className={`${block}__card-media`}>
                        <img src={media.url} />
                    </div>
                    <div className={`${block}__card-content`}>
                        <div className={`${block}__card-heading h4`}>
                            { heading }
                        </div>
                        {link &&
                        <div className={`${block}__card-link`}>
                            <Button {...{
                                id: `${link.id}`,
                                label : link.label,
                                mobileLabel: link.mobileLabel,
                                testId : `${link.id}`,
                                type: link.type.toLowerCase(),
                                cssAnimation: false,
                                dummyTag: true,
                                onClickCallback : () => {
                                    handleOnClick(link)
                                }, 
                            }}/>
                        </div> }
                    </div>
                </Tag>
            </CssAnimation>
        </>
    )
}